import { useState } from "react";

import { useAdminApiQueryWithParams } from "../../../hooks";
import {
  IRefundsSummary,
  IRefundOverview,
} from "../../../interfaces-and-types";
import { TSummaryPeriod } from "../../../constants";
import { ISummarySectionProps, ISummarySectionViewProps } from "../Home";

import { View } from "./View";

export interface IRefundsSummaryViewProps extends ISummarySectionViewProps<IRefundOverview> {}

export const RefundsSummary = ({
  activeCurrency,
  customChartPeriod,
}: ISummarySectionProps) => {
  const [summaryPeriod, setSummaryPeriod] = useState<TSummaryPeriod>("today");

  const {
    isLoading: isLoadingRefundsSummary,
    // isSuccess: isSuccessRefundsSummary,
    // isError: isErrorRefundsSummary,
    data: refundsSummary,
    refetch: refetchSummary,
  } = useAdminApiQueryWithParams<{ currency: string }, IRefundsSummary>(
    [
      "getRefundsSummary",
      {
        currency: activeCurrency!,
      },
    ],
    {
      enabled: !!activeCurrency,
    },
  );

  const {
    isLoading: isLoadingRefundsOverviewByPeriod,
    // isSuccess: isSuccessRefundsOverviewByPeriod,
    // isError: isErrorRefundsOverviewByPeriod,
    data: refundsOverviewByPeriod,
    refetch: refetchOverviewByPeriod,
  } = useAdminApiQueryWithParams<
    { currency: string; startDate: string; endDate: string },
    IRefundOverview
  >(
    [
      "getRefundsOverviewByPeriod",
      {
        currency: activeCurrency!,
        startDate: customChartPeriod.startDate,
        endDate: customChartPeriod.endDate,
      },
    ],
    {
      enabled:
        !!activeCurrency &&
        !!customChartPeriod.startDate &&
        !!customChartPeriod.endDate &&
        summaryPeriod === "custom",
    },
  );

  const refreshData =
    summaryPeriod === "custom" ? refetchOverviewByPeriod : refetchSummary;

  const summaryToDisplay =
    summaryPeriod === "today"
      ? refundsSummary?.today
      : summaryPeriod === "past week"
        ? refundsSummary?.past_week
        : summaryPeriod === "past month"
          ? refundsSummary?.past_month
          : summaryPeriod === "custom"
            ? refundsOverviewByPeriod
            : refundsSummary?.all_time;

  const isLoadingSummary =
    summaryPeriod === "custom"
      ? isLoadingRefundsOverviewByPeriod
      : isLoadingRefundsSummary;

  return (
    <View
      activeCurrency={activeCurrency}
      isLoadingSummary={isLoadingSummary}
      summaryToDisplay={summaryToDisplay || null}
      summaryPeriod={summaryPeriod}
      setSummaryPeriod={setSummaryPeriod}
      refreshData={refreshData}
    />
  );
};
